import type { RecordingSegmentPayload } from '@Application/Beneficiaries/Interviews/transferRecordingSegment';

export type RecordingSegmentTransferredAction = {
	type: 'RECORDING_SEGMENT_TRANSFERRED';
	payload: RecordingSegmentPayload;
	interviewId: number;
	recordingId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: RecordingSegmentPayload,
	interviewId: number,
	recordingId: number,
	typeKey: string,
	subjectId: number,
): RecordingSegmentTransferredAction => ({
	type: 'RECORDING_SEGMENT_TRANSFERRED',
	payload,
	interviewId,
	recordingId,
	typeKey,
	subjectId,
});
